// AuthCallback — the page Supabase redirects back to after OAuth.
// Supabase JS picks up the code from the URL via detectSessionInUrl;
// once the session is in place we navigate back to the app root.

import { useEffect } from 'react';
import { supabase } from './supabase';

export default function AuthCallback() {
  useEffect(() => {
    // detectSessionInUrl runs automatically on createClient. We just wait one
    // tick for it to finish, then redirect home.
    let cancelled = false;
    (async () => {
      await supabase.auth.getSession();
      if (cancelled) return;
      window.location.replace(import.meta.env.BASE_URL);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="cv-auth-callback">
      <p>Signing you in…</p>
    </div>
  );
}
